import ResponseHelper from "@/utils/httpUtil/impl/ResponseHelper";
import { extend } from "@utils/commonUtil";
import SentryUtil from "@/utils/sentryUtil";
import store from "../../../store";
import axios from "axios";
import { getIsBudgetHealthProjectAtivitySystemPermissionSession } from "@utils/userStorage";
const qs = require("qs");
// import { getSession } from "@utils/localStorageUtil";
const handleParamsFn = function (params = {}) {
  const state = store.state;
  // console.log("阿斯蒂芬士大夫",state);
  let comtyId = "";
  let bId = "";
  if (store.state.version === "v2") {
    comtyId = state.comtyIdNew || "";
  } else if (store.state.version === "v1") {
    comtyId = state.comtyId || "";
    bId = params.bId || state.bId || "";
  }
  // const token = getSession("token");
  params = {
    ...params,
    ...{
      bId
    }
  };
  if (comtyId && params.comtyId != "") {
    params.comtyId = params.communityId = params.comtyId || comtyId;
  }
  const BudgetHealthProjectAtivitySystemPermissionSession = getIsBudgetHealthProjectAtivitySystemPermissionSession();
  if (BudgetHealthProjectAtivitySystemPermissionSession) {
    params.healthServiceProjectId = BudgetHealthProjectAtivitySystemPermissionSession;
  }
  // params.type = "medicine";
  // params.operatorId = "5fb7a85e4576293d8762f4b6";
  // params.userId = "5fb7a85e4576293d8762f4b6";
  params.comtyType = "5";
  // console.log(params);
  return params;
};
export function createService(httpConfig) {
  const responseHelper = new ResponseHelper(httpConfig.ErrorArray);
  const service = axios.create({
    baseURL: httpConfig.baseURL,
    withCredentials: httpConfig.withCredentials,
    timeout: httpConfig.timeout
  });
  // eslint-disable-next-line
  const emptyFunction = function () {};
  function responseHandler(res) {
    if (httpConfig.responseInterceptor) {
      if (httpConfig.responseInterceptor(res)) {
        return new Promise(emptyFunction);
      }
    }
    if (res.status) {
      return res;
    } else {
      return Promise.reject(res);
    }
  }
  // 请求拦截
  // request interceptor
  service.interceptors.request.use(config => {
    // console.log("config", config);
    // do something before request is sent
    httpConfig.requestInterceptor && httpConfig.requestInterceptor(config);
    return config;
  }, error => {
    console.log("request-error:", error.response);
    SentryUtil.captureHttpError(error);
    const res = responseHelper.getResponseFromError(error.response);
    return responseHandler(res);
  });
  // 响应拦截
  // response interceptor
  service.interceptors.response.use(response => {
    const res = responseHelper.getResponse(response);
    return responseHandler(res);
  }, error => {
    SentryUtil.captureHttpError(error);
    const res = responseHelper.getResponseFromError(error.response);
    return responseHandler(res);
  });
  function request(option) {
    if (option.originalData === undefined) {
      option.originalData = true;
    }
    return service(option).then(res => {
      if (option.validator && option.validator(res) != true) {
        return Promise.reject(res);
      }
      if (option.originalData) {
        return Promise.resolve(res);
      } else {
        return Promise.resolve(res.data);
      }
    }).catch(err => {
      console.log("option", option);
      if (option.ignoreError != true) {
        httpConfig.errorHandler(err);
      }
      return Promise.reject(err);
    });
  }
  return {
    service,
    request
  };
}
export function createGET(request) {
  return function get(url, data, config) {
    data = handleParamsFn(data);
    const option = {
      url,
      method: "get",
      params: data || {}
    };
    extend(option, config);
    return request(option);
  };
}
export function createGETExFile(request) {
  return function get(url, data, config) {
    data = handleParamsFn(data);
    const option = {
      url,
      method: "get",
      params: data || {},
      responseType: "blob"
    };
    extend(option, config);
    return request(option);
  };
}
export function createPostExFile(request) {
  return function post(url, data, config) {
    data = handleParamsFn(data);
    const option = {
      url,
      method: "post",
      data: data || {},
      responseType: "blob"
    };
    extend(option, config);
    return request(option);
  };
}
export function createGETForm(request) {
  return function get(url, data, config) {
    const option = {
      url,
      method: "get",
      data: qs.stringify(data || {}),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    };
    extend(option, config);
    return request(option);
  };
}
export function createPOST(request) {
  return function post(url, data, config) {
    data = handleParamsFn(data);
    const option = {
      url,
      method: "post",
      data: data || {}
    };
    extend(option, config);
    return request(option);
  };
}
export function createPOSTForm(request) {
  return function post(url, data, config) {
    const option = {
      url,
      method: "post",
      data: qs.stringify(data || {}),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    };
    extend(option, config);
    return request(option);
  };
}
export function createPOSTFormData(request) {
  return function post(url, data, config) {
    const option = {
      url,
      method: "post",
      data: data || {},
      headers: {
        "Content-Type": "multipart/form-data"
      }
    };
    extend(option, config);
    console.log(option);
    return request(option);
  };
}
export function createPUT(request) {
  return function put(url, data, config) {
    data = handleParamsFn(data);
    const option = {
      url,
      method: "put",
      data: data || {}
    };
    extend(option, config);
    return request(option);
  };
}
export function createPUTForm(request) {
  return function put(url, data, config) {
    const option = {
      url,
      method: "put",
      data: qs.stringify(data || {}),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    };
    extend(option, config);
    return request(option);
  };
}
export function createDEL(request) {
  return function del(url, data, config) {
    data = handleParamsFn(data);
    const option = {
      url,
      method: "delete",
      params: data || {}
    };
    extend(option, config);
    return request(option);
  };
}
export function createPATCH(request) {
  return function patch(url, data, config) {
    data = handleParamsFn(data);
    const option = {
      url,
      method: "patch",
      data: data || {},
      headers: {
        "Content-Type": "x-www-form-urlencoded"
      }
    };
    extend(option, config);
    return request(option);
  };
}